import { overlay } from 'overlay-kit';
import { CitePostsDialog } from './cite-posts-dialog';

export const showCitePostsDialog = (postIds: string[]): Promise<void> => {
  return new Promise((resolve) => {
    return overlay.open(({ isOpen, close }) => {
      if (!isOpen) return null;

      const onClose = () => {
        close();
        resolve();
      };
      return <CitePostsDialog title="Posts" postIds={postIds} isOpen={isOpen} onClose={onClose} />;
    });
  });
};
